import React, { useState, useEffect } from "react";
import { Table } from "antd";
import EmptyState from "./TWComponents/EmptyState";
import pointsHistory from "../images/icons/points-history.svg";

export default function AccountPointHistory({
  data,
  langData,
  currentPage,
  defaultPerPage,
  setCurrentPage,
  setDefaultPerPage,
  openWidgetAction,
}) {
  const columns = [
    {
      title: langData.title_processed_date,
      dataIndex: "processed_date",
      key: "processed_date",
      fixed: true,
      width: 110,
    },
    {
      title: langData.title_description,
      dataIndex: "description",
      key: "description",
      width: 220,
    },
    {
      title: langData.title_place_of_visit,
      dataIndex: "place_of_visit",
      key: "place_of_visit",
      width: 220,
    },
    {
      title: langData.title_transaction_reference,
      dataIndex: "transaction_reference",
      key: "transaction_reference",
      width: 110,
    },
    {
      title: langData.title_transaction_type,
      dataIndex: "transaction_type",
      key: "transaction_type",
    },
    {
      title: langData.title_earned_point,
      dataIndex: "earned_points",
      key: "earned_points",
      align: "right",
      width: 80,
    },
    {
      title: langData.title_bonus_point,
      dataIndex: "bonus_points",
      key: "bonus_points",
      align: "right",
      width: 80,
    },
    {
      title: langData.title_total_point,
      dataIndex: "total_points",
      key: "total_points",
      align: "right",
      width: 80,
    },
  ];

  const [result, setReult] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dataTabel();
  }, [data]);

  const dataTabel = () => {
    if (process.env.GATSBY_ENABLE_AUTH0 !== "true") {
      if (data.data !== undefined) {
        let obj = [];
        data.data.map(function (val, index) {
          obj[index] = {
            processed_date: val.processed_date,
            description: val.description,
            place_of_visit: val.place_of_visit,
            transaction_reference: val.transaction_reference,
            transaction_type: val.transaction_type,
            earned_points: val.earned_points.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            }),
            bonus_points: val.bonus_points.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            }),
            total_points: val.total_points.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            }),
            points_expired: val.points_expired,
          };
        });
        setReult(obj);
        setLoading(false);
      }
    }

    if (process.env.GATSBY_ENABLE_AUTH0 === "true") {
      if (data.data !== undefined) {
        let obj = [];
        data.data.map(function (val, index) {
          obj[index] = {
            processed_date: val.processedDate,
            description: val.description,
            place_of_visit: val.placeOfVisit,
            transaction_reference: val.transactionReference,
            transaction_type: val.transactionType,
            earned_points: val.earnedPoints.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            }),
            bonus_points: val.bonusPoints.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            }),
            total_points: val.totalPoints.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            }),
            points_expired: val.pointsExpired,
          };
        });
        setReult(obj);
        setLoading(false);
      }
    }
  };

  const onChangePages = (page, pageSize) => {
    setCurrentPage(page);
    setDefaultPerPage(pageSize);
    setLoading(true);
  };

  return result.length == 0 && !loading ? (
    <EmptyState
      icon={pointsHistory}
      description={langData.points_emptynote}
      buttonTitle={langData.explore_hotel}
      openWidgetAction={openWidgetAction}
      tab="pointsHistory"
    />
  ) : (
    <Table
      size="small"
      scroll={{ x: 1100 }}
      columns={columns}
      loading={loading}
      dataSource={result}
      bordered={true}
      pagination={{
        hideOnSinglePage: true,
        responsive: true,
        defaultCurrent:
          process.env.GATSBY_ENABLE_AUTH0 === "true"
            ? data.pagination?.currentPage
            : data.page?.current_page,
        current:
          process.env.GATSBY_ENABLE_AUTH0 === "true"
            ? data.pagination?.currentPage
            : data.page?.current_page,
        defaultPageSize: defaultPerPage,
        onChange: onChangePages,
        total:
          process.env.GATSBY_ENABLE_AUTH0 === "true"
            ? data.pagination?.total
            : data.page?.total,
      }}
    />
  );
}
